import { render, staticRenderFns } from "./Contact-Detail.vue?vue&type=template&id=3d09cf65"
import script from "./Contact-Detail.vue?vue&type=script&lang=js"
export * from "./Contact-Detail.vue?vue&type=script&lang=js"
import style0 from "./Contact-Detail.vue?vue&type=style&index=0&id=3d09cf65&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports